import Endpoints from 'constants/Endpoints';
import {RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from 'libs/RestRequest';
import {clearResource, setResource, setSaveStatusError} from 'redux/actions'
import reduxStore from 'redux/store'
import downloadFileWithPreloadUrl from "../libs/downloadFileWithPreloadUrl";
import Tr from "../translations/Translations";
import validateSection from "./helpers/validateSection";
import {DemandValidation} from "../constants/DemandValidation";

const RESULT_NOTICE_RESOURCE_ID = 'resultNotice';

const getResultNotice = async (demandId) => {
    const resp = await RestRequestGET(Endpoints.RESULT_NOTICE(demandId));
    reduxStore.dispatch(setResource(RESULT_NOTICE_RESOURCE_ID, resp));
    await validateSection(DemandValidation.RESULT_NOTICE, demandId,false);
};

const addResultNoticeAttachments = async (demandId, files) => {
    const resp = await RestRequestPOST(Endpoints.RESULT_NOTICE(demandId), {list: files});
    reduxStore.dispatch(setResource(RESULT_NOTICE_RESOURCE_ID, resp))
    await validateSection(DemandValidation.RESULT_NOTICE, demandId,false);
};

const publishOjsResultNotice = async (demandId) => {
    return await RestRequestPOST(Endpoints.RESULT_NOTICE_PUBLISH_OJS_NOTICE(demandId));
};

const checkOjsResultNotice = async (demandId) => {
    try {
        const res = await RestRequestGET(Endpoints.RESULT_NOTICE_CHECK_OJS_NOTICE(demandId));
        reduxStore.dispatch(
            setResource('resultOjsPublicationStatus', res)
        )
        return res;
    } catch (error) {
    }
};

const rollbackOjsResultNotice = async (demandId) => {
    return await RestRequestPOST(Endpoints.RESULT_NOTICE_ROLLBACK_OJS_NOTICE(demandId));
};

const getDownloadFile = async (demandId, resultNoticeId, resultFileId, openInBrowser) => {
    await downloadFileWithPreloadUrl(
        Endpoints.RESULT_NOTICE_DOWNLOAD_FILE_URL(demandId, resultNoticeId, resultFileId, openInBrowser),
        openInBrowser);
}

const deleteResultNotice = async (demandId, resultNoticeId, resultNoticeAttachmentId) => {
    const resp = await RestRequestDELETE(Endpoints.RESULT_NOTICE_DELETE(demandId, resultNoticeId, resultNoticeAttachmentId))
    const {resources} = reduxStore.getState();
    const res = {
        ...resources[RESULT_NOTICE_RESOURCE_ID],
        attachments: resources[RESULT_NOTICE_RESOURCE_ID].attachments.filter(x => x.identity !== resp.result)
    };
    reduxStore.dispatch(setResource(RESULT_NOTICE_RESOURCE_ID, res))
    await validateSection(DemandValidation.RESULT_NOTICE, demandId,false);
}

const publishResultNoticeAttachment = async (demandId, resultNoticeId, resultNoticeAttachmentId) => {
    const resp = await RestRequestPUT(Endpoints.RESULT_NOTICE_ATTACHMENT_PUBLISH(demandId, resultNoticeId, resultNoticeAttachmentId));
    checkAndUpdateAttachment(resp);
    await validateSection(DemandValidation.RESULT_NOTICE, demandId,false);
};

const unpublishResultNoticeAttachment = async (demandId, resultNoticeId, resultNoticeAttachmentId) => {
    const resp = await RestRequestPUT(Endpoints.RESULT_NOTICE_ATTACHMENT_UNPUBLISH(demandId, resultNoticeId, resultNoticeAttachmentId));
    checkAndUpdateAttachment(resp);
    await validateSection(DemandValidation.RESULT_NOTICE, demandId,false);
};

const publishResultNotice = async (demandId) => {
    const resp = await RestRequestPUT(Endpoints.RESULT_NOTICE_PUBLISH(demandId));
    reduxStore.dispatch(setResource(RESULT_NOTICE_RESOURCE_ID, resp.result));
    return resp;
};

const unpublishResultNotice = async (demandId) => {
    const resp = await RestRequestPUT(Endpoints.RESULT_NOTICE_UNPUBLISH(demandId));
    reduxStore.dispatch(setResource(RESULT_NOTICE_RESOURCE_ID, resp.result));
    return resp;
};

const updateDescription = async (demandId, {resultNoticeId, resultNoticeAttachmentId}, description) => {
    const resp = await RestRequestPUT(Endpoints.RESULT_NOTICE_DESCRIPTION(demandId, resultNoticeId, resultNoticeAttachmentId), {description});
    checkAndUpdateAttachment(resp);
};

const updateNoticeReferenceNumber = async (demandId,  {resultNoticeId, resultNoticeAttachmentId}, noticeReferenceNumber) => {
    const resp = await RestRequestPUT(Endpoints.RESULT_NOTICE_REFERENCE_NUMBER(demandId, resultNoticeId, resultNoticeAttachmentId), {noticeReferenceNumber});
    checkAndUpdateAttachment(resp);
}

const checkAndUpdateAttachment = (resp) => {
    try {
        if (resp?.success) {
            const {resources} = reduxStore.getState();
            const res = {
                ...resources[RESULT_NOTICE_RESOURCE_ID],
                attachments: resources[RESULT_NOTICE_RESOURCE_ID].attachments.map(x => x.identity === resp.result.identity ? resp.result : x)
            };
            reduxStore.dispatch(setResource(RESULT_NOTICE_RESOURCE_ID, res))
        } else {
            throw new Error(resp);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}
const getDownloadHistory = async (demandId, {resultNoticeId, resultNoticeAttachmentId}, pagination) => {

    const params = {
        ...pagination
    }

    const url = Endpoints.RESULT_NOTICE_DOWNLOAD_FILE_HISTORY(demandId, resultNoticeId, resultNoticeAttachmentId, params);
    const siwzDownloadHistory = await RestRequestGET(url, {params});
    return siwzDownloadHistory;
}
const validate = async (id) => {
    return RestRequestGET(Endpoints.RESULT_NOTICE_VALIDATE(id));
}

const clearResultNoticeResources = () => {
    reduxStore.dispatch(clearResource(RESULT_NOTICE_RESOURCE_ID));
};

const addBzpNotice = async (demandId, bzpNoticeId) => {
    const url = Endpoints.RESULT_NOTICE_BZP(demandId)

    const data = {
        bzpNoticeId
    }

    return await RestRequestPOST(url, data);
}

const buildIdentity = (resultNoticeId, resultNoticeAttachmentId) => ({resultNoticeId, resultNoticeAttachmentId});

export default {
    getResultNotice,
    publishOjsResultNotice,
    checkOjsResultNotice,
    rollbackOjsResultNotice,
    addResultNoticeAttachments,
    getDownloadFile,
    deleteResultNotice,
    publishResultNotice,
    unpublishResultNotice,
    unpublishResultNoticeAttachment,
    publishResultNoticeAttachment,
    getDownloadHistory,
    updateDescription,
    updateNoticeReferenceNumber,
    validate,
    clearResultNoticeResources,
    addBzpNotice,
    buildIdentity,
    RESULT_NOTICE_RESOURCE_ID
}